import React, {useState} from "react";
import {css} from "@emotion/react";

import {p} from "@pg-design/helpers-css";
import {Modal} from "@pg-design/modal-module";
import {priceM2Format} from "@pg-mono/string-utils";

import {IQuartileBarProps, QuartileBar} from "../QuartileBar";

interface IMobileQuartileBarProps extends IQuartileBarProps {
    children: React.ReactNode;
}

export const MobileQuartileBar: React.FC<IMobileQuartileBarProps> = (props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const closeModal = () => setIsModalOpen(false);
    const openModal = () => setIsModalOpen(true);

    return (
        <>
            <Modal isOpen={isModalOpen} onModalClose={closeModal}>
                <Modal.Header variant="bar_mini">Średnia cena nieruchomości</Modal.Header>
                <Modal.Content css={[p(4, 5, 0, 5)]}>
                    <p css={avgPricePar}>
                        Średnia cena nieruchomości w tej lokalizacji <strong>{priceM2Format(props.avgPrice)}.</strong>
                    </p>
                    <QuartileBar
                        avgPrice={props.avgPrice}
                        firstQuartile={props.firstQuartile}
                        secondQuartile={props.secondQuartile}
                        thirdQuartile={props.thirdQuartile}
                    />
                </Modal.Content>
            </Modal>
            <div onClick={openModal}>{props.children}</div>
        </>
    );
};

const avgPricePar = css`
    margin-bottom: 4.5rem;
`;
import React, {useState} from "react";
import {css} from "@emotion/react";

import {p} from "@pg-design/helpers-css";
import {Modal} from "@pg-design/modal-module";
import {priceM2Format} from "@pg-mono/string-utils";

import {IQuartileBarProps, QuartileBar} from "../QuartileBar";

interface IMobileQuartileBarProps extends IQuartileBarProps {
    children: React.ReactNode;
}

export const MobileQuartileBar: React.FC<IMobileQuartileBarProps> = (props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const closeModal = () => setIsModalOpen(false);
    const openModal = () => setIsModalOpen(true);

    return (
        <>
            <Modal isOpen={isModalOpen} onModalClose={closeModal}>
                <Modal.Header variant="bar_mini">Średnia cena nieruchomości</Modal.Header>
                <Modal.Content css={[p(4, 5, 0, 5)]}>
                    <p css={avgPricePar}>
                        Średnia cena nieruchomości w tej lokalizacji <strong>{priceM2Format(props.avgPrice)}.</strong>
                    </p>
                    <QuartileBar
                        avgPrice={props.avgPrice}
                        firstQuartile={props.firstQuartile}
                        secondQuartile={props.secondQuartile}
                        thirdQuartile={props.thirdQuartile}
                    />
                </Modal.Content>
            </Modal>
            <div onClick={openModal}>{props.children}</div>
        </>
    );
};

const avgPricePar = css`
    margin-bottom: 4.5rem;
`;
